import classNames from "classnames/dedupe";
import { Container } from "@simplybusiness/mobius";
import { Logo } from "../Logo";
import type { WithMetadata } from "../../../pages";
import type { HeaderProps } from "../types";
import { ContactDetails } from "../ContactDetails";
import { PoweredBySB } from "./PoweredBySB";
import "./GoCompareHeader.css";

export function GoCompareHeader(props: WithMetadata<HeaderProps>) {
  const {
    componentName,
    variant,
    className,
    productTitle,
    phoneNumber,
    openingHours,
    supportUrl,
    openingHoursLabel = "See our opening hours",
  } = props;
  const classes = classNames("mobius", "mobius-header", className);

  return (
    <header
      className={classes}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
    >
      <div className="mobius-header__container">
        <Container size="sm" className="mobius-header__content">
          <div className="mobius-header-gocompare__logo-block">
            <Logo url="https://gocompare.com/" />
            {productTitle && (
              <span className="mobius-header-gocompare__product-title">
                {productTitle}
              </span>
            )}
          </div>
          <PoweredBySB />
          <ContactDetails
            phoneNumber={phoneNumber}
            openingHours={openingHours}
            supportUrl={supportUrl}
            openingHoursLabel={openingHoursLabel}
          />
        </Container>
      </div>
    </header>
  );
}
